import React, { useState } from "react";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "../MathCalculator/MainCalculators";
const TITLE = "حاسبة كتلة الأرض - احسب الكتلة باستخدام قانون الجذب العام";
const DESCRIPTION =
  "استخدم حاسبة كتلة الأرض المتقدمة لحساب الكتلة الدقيقة للأرض بناءً على قانون الجذب العام لنيوتن. توفر هذه الأداة طريقة موثوقة وسهلة لحساب كتلة كوكبنا، مما يساعد في فهم مفاهيم فيزيائية مثل الجاذبية والأثر الذي تتركه على الأجسام. احصل على تقدير دقيق لكتلة الأرض بسرعة وسهولة.";
const KEYWORDS =
  "كتلة الأرض, حساب كتلة الأرض, قانون الجذب العام, حاسبة فيزياء, حسابات فيزيائية";
const OG_URL = "https://do-calculate.com/calculator/ar/earth-mass-calculator/";
const EarthMassCalculator = () => {
  const [gravity, setGravity] = useState(9.8);
  const [radius, setRadius] = useState(6.4e6);
  const [gConstant, setGConstant] = useState("");
  const [mass, setMass] = useState("");
  const [error, setError] = useState("");
  const calculateMass = (gravity, radius, gConstant) => {
    return (gravity * Math.pow(radius, 2)) / gConstant;
  };
  const handleCalculate = () => {
    try {
      const gravityValue = parseFloat(gravity);
      const radiusValue = parseFloat(radius);
      const gConstantValue = parseFloat(gConstant);
      if (gravity && radius && gConstant) {
        const calculatedMass = calculateMass(
          gravityValue,
          radiusValue,
          gConstantValue
        );
        setMass(calculatedMass.toExponential(2) + " كيلوجرام");
        setError("");
      } else {
        throw new Error("يرجى إدخال جميع القيم لحساب كتلة الأرض.");
      }
    } catch (err) {
      setError(err.message);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>حاسبة كتلة الأرض</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  حاسبة كتلة الأرض هي أداة متقدمة تساعدك على حساب الكتلة الدقيقة
                  للأرض باستخدام قانون الجذب العام لنيوتن. تعتمد هذه الحاسبة على
                  مجموعة من المعطيات الفيزيائية الأساسية مثل عجلة الجاذبية
                  الأرضية، ونصف قطر الأرض، وثابت الجاذبية العالمي. بفضل هذه
                  الأداة، يمكنك الحصول على تقدير دقيق لكتلة كوكبنا، مما يساعد في
                  تعزيز فهمك لمفاهيم فيزيائية مثل الجاذبية وكيفية تأثيرها على
                  الأجسام في الفضاء.
                </p>
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>حاسبة كتلة الأرض</h2>
                </div>
                <hr />
                <div dir="rtl">
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          عجلة الجاذبية الأرضية (a)
                        </label>
                      </b>
                      <input
                        type="text"
                        placeholder="9.8"
                        value={gravity}
                        onChange={(e) => setGravity(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                        disabled
                      />
                      <span className="ms-2">متر/ث²</span>
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          نصف قطر الأرض (r)
                        </label>
                      </b>
                      <input
                        type="text"
                        placeholder="6.4e6"
                        value={radius}
                        onChange={(e) => setRadius(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                        disabled
                      />
                      <span className="ms-2">متر</span>
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          ثابت الجاذبية (G)
                        </label>
                      </b>
                      <input
                        type="text"
                        placeholder="أدخل ثابت الجاذبية"
                        value={gConstant}
                        onChange={(e) => setGConstant(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                      <span className="ms-2">متر³/كجم·ث²</span>
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      احسب                    </button>
                    <br />
                    { error && (
                      <p style={{ color: "red" }}>{error}</p>
                    )}
                    <br />
                    { mass && (
                      <div className="p-3 mb-2 bg-success text-white">
                        <hr />
                        <p>النتائج:</p>
                        <p>كتلة الأرض: {mass}</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr /><div className="row">
              <RelatedLinks />
              <hr style={{ width: "100%" }} />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="col-12 col-md-8">
        <div className="info-sections-container">
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>ما هي كتلة الأرض؟</h3>
            </div>
            <div className="info-section-body">
              <p>
                كتلة الأرض هي الكمية المادية التي تحتوي عليها الأرض. يتم حسابها
                باستخدام قانون الجذب العام لنيوتن، والذي يربط بين الكتلة والقوة
                والجاذبية.
              </p>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>أهمية معرفة كتلة الأرض</h3>
            </div>
            <div className="info-section-body">
              <p>
                معرفة كتلة الأرض أمر حيوي لفهم العديد من الظواهر الطبيعية مثل
                حركة الأقمار الاصطناعية، المد والجزر، وتفاعلات الجاذبية بين
                الأرض والكواكب الأخرى.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default EarthMassCalculator;
